import { Platform, StyleSheet } from 'react-native';
import { theme } from '@garnish/constants';

export const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  labelWithSpacing: {
    paddingBottom: theme.spacing['2'],
  },
  triggerWrapper: {
    position: 'relative',
  },
  trigger: {
    paddingVertical: theme.spacing['1'],
    borderRadius: theme.radius.medium,
  },
  triggerHover: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: theme.colors.OPACITY.GREEN_1.ALMOST_TRANSPARENT,
    borderRadius: theme.radius.medium,
    marginHorizontal: -theme.spacing['2'],
  },
  triggerBox: {
    borderRadius: theme.radius.small,
    borderWidth: 1,
    borderColor: theme.colors.GRAY,
    paddingVertical: 0,
    paddingHorizontal: theme.spacing['2'],
    minHeight: 32,
  },
  select: {
    top: 0,
    left: 0,
    zIndex: theme.zIndex.dropdown,
  },
  scrollView: {
    overflow: 'scroll',
    maxHeight: 200,
  },
  options: {
    overflow: 'hidden',
    marginTop:
      Platform.OS === 'android' ? -theme.spacing['4'] : theme.spacing['1'],
    marginBottom: theme.spacing['2'],
    backgroundColor: theme.colors.KHAKI_3,
    borderColor: theme.colors.GREEN_1,
    borderRadius: theme.radius.medium,
    borderWidth: 1,
  },
  option: {
    paddingHorizontal: 12,
    paddingVertical: 10,
  },
  optionDisabled: {
    backgroundColor: theme.colors.OPACITY.TRANSPARENT,
  },
  hovered: {
    backgroundColor: theme.colors.OPACITY.GREEN_1.ALMOST_TRANSPARENT,
  },
  pressed: {
    backgroundColor: theme.colors.OPACITY.GREEN_1.LIGHTER,
  },
  selected: {
    backgroundColor: theme.colors.OPACITY.GREEN_2.LIGHTER,
  },
  disabled: {
    color: theme.colors.OPACITY.GREEN_1.LIGHT,
  },
});
